import { ChangeDetectionStrategy, Component, EventEmitter, inject, input, InputSignal, Output } from '@angular/core';
import { NAVIGATION_TOKEN, NavigationProvider } from '@core';
import { SzActionMenuComponent } from '../../chrome/sz-action-menu';
import { SzActionMenuItem } from '../../chrome/sz-action-menu/sz-action-menu.types';
import { SzIconComponent } from '../sz-icon';
import { SzPageTitleSize } from './sz-page-title.types';

@Component({
  selector: 'sz-page-title',
  templateUrl: './sz-page-title.component.html',
  styleUrls: ['./sz-page-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzIconComponent, SzActionMenuComponent]
})
export class SzPageTitleComponent {
  readonly title: InputSignal<string> = input.required<string>();
  readonly accent: InputSignal<string | null> = input<string | null>(null);
  readonly size: InputSignal<SzPageTitleSize> = input<SzPageTitleSize>('lg');
  readonly showBack: InputSignal<boolean> = input<boolean>(false);
  readonly backAriaLabel: InputSignal<string> = input<string>('Back');
  readonly actionItems: InputSignal<readonly SzActionMenuItem[]> = input<readonly SzActionMenuItem[]>([]);
  readonly actionsAriaLabel: InputSignal<string> = input<string>('Actions');

  @Output() readonly back: EventEmitter<void> = new EventEmitter<void>();
  @Output() readonly actionSelect: EventEmitter<string> = new EventEmitter<string>();

  private readonly navigation: NavigationProvider = inject(NAVIGATION_TOKEN);

  onBackClick(): void {
    if (this.back.observed) {
      this.back.emit();
      return;
    }
    this.navigation.back();
  }

  onActionSelect(id: string): void {
    this.actionSelect.emit(id);
  }
}
